<template>
	<div class="sy-ch-main container-fluid mt4">
		<div class="container500">
			<!-- <router-link v-bind:to = "{path: tab.path}" v-for = "(tab,index) in navPaths" :key = "index"> 
				<div :id = "'profileManagerNavs' + index" class="profileManagerNavs btn mb3" style="display:block;width:100%;font-size:20px">
					{{tab.name}}
				</div>
			</router-link> -->
			<router-view></router-view>
		</div>
	</div>
</template>
<script>
var dbPath, docID;
export default{
	data(){
		var prefix = "/" + this.$route.params.businessID;
		return{
			navPaths:[
			{
				path: prefix + '/profile-manager/update-password',
				name: 'Update Password',
			},
			{
				path: prefix + '/profile-manager/update-email',
				name: 'Update Email',
			},
			],
			oriItem: {},
		}
	},
	mounted(){
		this.checkPath();
		customJS.runAll();
	},
	firestore(){
		dbPath = "business/" + this.$route.params.businessID + "/admins";
		docID = myFB.auth.currentUser.uid;
		return {
			oriItem: myFB.db.collection(dbPath).doc(docID),
		}
	},
	watch:{
		"$route":function(){
			this.checkPath();
		}
	},
	methods:{
		checkPath(){
			var path = this.$route.path;
			var allPaths = [];

			this.navPaths.forEach((r, index)=>{
				allPaths.push(r.path);
				$("#profileManagerNavs" + index).removeClass("selectedNav");
			})


			var chosenIndex = allPaths.indexOf(path);
			console.log(chosenIndex)
			$("#profileManagerNavs" + chosenIndex).addClass("selectedNav");
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/ProfileManager.vue